<template>
  <div
    class="advertiserContainer"
    :style="{ height: isQuickStart ? 'calc(100vh - 48px)' : '100vh' }"
    :class="{ 'mt-12': isQuickStart }"
  >
    <v-row
      class="advertiserContent justify-space-between"
      :class="{ mobileAdvertiserContent: isMobileSized }"
    >
      <v-col
        :cols="isMobileSized ? 12 : 5"
        class="d-flex"
        style="position:relative;"
        :class="isMobileSized ? 'mt-16 px-6' : 'px-10'"
        :style="isMobileSized ? '' : 'height:100%;'"
      >
        <div :class="{ mobileDisplayContainer: isMobileSized }">
          <StepIcons :currentView="'advertiser'" :isMobileSized="isMobileSized" />
          <v-row no-gutters align="center" :style="isMobileSized ? '' : 'height:54vh'">
            <div>
              <div
                class="text-h4 font-weight-bold advertiserTitle"
                :class="{ mobileTitle: isMobileSized }"
              >
                Let's Plan Your Ad Campaign!
              </div>
              <p
                class="largeDescriptionText"
                :class="isMobileSized ? 'mobileDescriptionText mt-2 mb-0' : 'mt-6'"
              >
                Please let us know the following:
              </p>
              <ul>
                <li
                  class="largeDescriptionText"
                  :class="isMobileSized ? 'mobileDescriptionText' : ''"
                  >the business/brand these ads are promoting</li
                >
                <li
                  class="largeDescriptionText"
                  :class="isMobileSized ? 'mobileDescriptionText' : ''"
                  >your desired schedule for the ads to be served, including start/end dates, and
                  days of the week</li
                >
                <li
                  class="largeDescriptionText"
                  :class="isMobileSized ? 'mobileDescriptionText' : ''"
                  >Where in the world you would like your ads to be seen - countries/regions/cities
                  (only country is required; region and city are optional)</li
                >
              </ul>
              <p
                class="largeDescriptionText"
                :class="isMobileSized ? 'mobileDescriptionText mt-2 mb-0' : 'mt-6'"
              >
                You can ignore schedule and location targeting if you plan on using a third-party
                DSP.
              </p>
            </div>
          </v-row>
        </div>
      </v-col>
      <v-col
        class="d-flex justify-center"
        style="background-color: rgb(94, 0, 235);"
        :style="isMobileSized ? 'padding-bottom: 166px;' : `height:100%;`"
      >
        <div v-if="isLoadingFems" class="d-flex advertiserFormLoadingIndicator">
          <v-progress-circular
            :size="200"
            :width="8"
            indeterminate
            color="blue darken-2"
          ></v-progress-circular>
        </div>
        <div
          :style="{
            display: isLoadingFems ? 'none' : 'block',
            height: isMobileSized ? '' : '90%',
            overflow: 'auto',
          }"
          class="advertiserDataContainer"
          :class="isMobileSized ? 'px-3' : 'pl-6 pr-8 py-5'"
        >
          <div class="text-h6 white--text" :class="isMobileSized ? 'mobileQuestion mt-2 mb-3' : ''"
            >Who are these ads for?</div
          >
          <div
            id="advertiser-form"
            :data-adacado-dataset="advertiserFormDataset"
            style="background-color: white; border-radius: 20px;"
          >
            <div v-pre class="advertiserFormWrapper"></div>
          </div>
          <div class="text-h6 white--text" :class="isMobileSized ? 'mobileQuestion mt-4 mb-3' : ''"
            >When do you want these ads to be served?</div
          >
          <Scheduling
            :schedule="scheduleData"
            :isQuickStart="isQuickStart"
            :isMobileSized="isMobileSized"
            @updateSchedule="updateSchedule"
          />
          <div class="text-h6 white--text" :class="isMobileSized ? 'mobileQuestion mt-4 mb-3' : ''"
            >Where would you like these ads to be displayed?</div
          >
          <!-- Location Targeting Modal -->
          <div
            id="media-channel-geo-targeting"
            :data-adacado-dataset="targetingDataset"
            style="background-color: white; border-radius: 20px;"
          >
            <div v-pre></div>
          </div>
        </div>
        <div class="backNextButtonDisplay" :class="{ mobileBackNextButtonDisplay: isMobileSized }">
          <v-btn
            class="mr-3"
            dark
            color="grey lighten-1"
            @click="
              guibus_publish('dispatch:beacon', {
                eventId: `welcome-advertiser_slide_back_button-click${
                  isMobileSized ? '-mobile' : ''
                }`,
              })
              $emit('changeStep', 'ads')
            "
            >Back</v-btn
          >
          <v-btn
            :disabled="isNextStepDisabled"
            class="white--text"
            color="primary"
            @click="
              guibus_publish('dispatch:beacon', {
                eventId: `welcome-advertiser_slide_next_button-click${
                  isMobileSized ? '-mobile' : ''
                }`,
              })
              $emit('changeStep', 'launch')
            "
            >Next</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StepIcons from '../units/StepIcons.vue'
import Parameter from 'parameter-mixin'
import Scheduling from '../units/Scheduling.vue'
import FemsService from 'fems-service'

export default {
  mixins: [Parameter],
  props: {
    isShopifyUser: {
      type: Boolean,
      default: false,
    },
    vertical: {
      type: String,
      default: 'retail',
    },
    subVertical: {
      type: String,
      default: undefined,
    },
    currentAdvertiserData: {
      type: Object,
      default: undefined,
    },
    schedule: {
      type: Object,
      default: undefined,
    },
    currentCartography: {
      type: Array,
      default: undefined,
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StepIcons,
    Scheduling,
  },
  data() {
    return {
      isLoadingAdvertiserForm: true,
      isLoadingGeo: true,
      advertiserData: this.currentAdvertiserData,
      scheduleData: this.schedule,
      selectedCartography: this.currentCartography,
    }
  },
  mounted() {
    this.guibus_subscribe('mounted:advertiserFormFems', this.handleAdvertiserFormMounted)
    this.guibus_subscribe('loaded:targetingFems', this.handleGeoTargetingFemsLoaded)
    this.guibus_subscribe('store:advertiserData', this.handleAdvertiserData)
    this.guibus_subscribe('change:geo', this.handleGeoData)
    FemsService.renderChildFems('advertiser-form', 'v2')
    FemsService.renderChildFems('media-channel-geo-targeting', 'v1')
  },
  beforeDestroy() {
    this.guibus_unsubscribe('mounted:advertiserFormFems', this.handleAdvertiserFormMounted)
    this.guibus_unsubscribe('loaded:targetingFems', this.handleGeoTargetingFemsLoaded)
    this.guibus_unsubscribe('store:advertiserData', this.handleAdvertiserData)
    this.guibus_unsubscribe('change:geo', this.handleGeoData)
    FemsService.teardownChildFems('advertiser-form', 'v2')
    FemsService.teardownChildFems('media-channel-geo-targeting', 'v1')
  },
  computed: {
    isNextStepDisabled() {
      return !this.advertiserData || !this.scheduleData || !this.selectedCartography?.length
    },
    advertiserSlideData() {
      return {
        advertiser: this.advertiserData,
        schedule: this.scheduleData,
        selectedCartography: this.selectedCartography,
      }
    },
    isLoadingFems() {
      return this.isLoadingAdvertiserForm || this.isLoadingGeo
    },
    advertiserFormDataset() {
      return this.$constructAdacadoDataset({
        isCreatingNewAdvertiser: true,
        titleText: ' ',
        btnText: 'Next',
        isQuickStart: this.isQuickStart,
        isOnboarding: !this.isQuickStart,
        isShopifyUser: this.isShopifyUser,
        vertical: this.vertical,
        subVertical: this.subVertical,
        quickStartAdvertiserData: this.advertiserData || {},
        isMobileSized: this.isMobileSized,
      })
    },
    targetingDataset() {
      return this.$constructAdacadoDataset({
        advertiser: this.advertiserData || {},
        mediaChannelType: 'dspcentro',
        isQuickStart: true,
        isMobileSized: this.isMobileSized,
      })
    },
  },
  methods: {
    handleGeoData(data) {
      this.selectedCartography = data.SelectedCartography
      this.$emit('handleAdvertiserData', this.advertiserSlideData)
    },
    updateSchedule(data) {
      this.scheduleData = data
      this.$emit('handleAdvertiserData', this.advertiserSlideData)
    },
    handleAdvertiserData(data) {
      this.advertiserData = data
      if (!this.selectedCartography?.length) {
        FemsService.teardownChildFems('media-channel-geo-targeting', 'v1')
        this.$nextTick(() => {
          FemsService.renderChildFems('media-channel-geo-targeting', 'v1')
        })
      }
      this.$emit('handleAdvertiserData', this.advertiserSlideData)
    },
    handleGeoTargetingFemsLoaded() {
      this.isLoadingGeo = false
    },
    handleAdvertiserFormMounted() {
      this.isLoadingAdvertiserForm = false
    },
  },
}
</script>

<style lang="scss" scoped>
.advertiserContainer {
  width: 100vw;
  height: 100%;
  .advertiserContent {
    display: flex;
    height: 100%;
    position: relative;
    width: 100%;
    margin: auto;
    align-items: center;
    &.mobileAdvertiserContent {
      height: unset;
    }
  }
}
.advertiserDataContainer {
  .mobileQuestion {
    font-size: 1rem !important;
    line-height: 1;
  }

  &::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e6e6e6;
    border-left: 1px solid #dadada;
  }

  &::-webkit-scrollbar-thumb {
    background: #b0b0b0;
    border: solid 3px #e6e6e6;
    border-radius: 7px;
  }
}
::v-deep .v-application--wrap {
  min-height: unset;
}

::v-deep .v-card {
  border-radius: 20px !important;
}

.mobileDisplayContainer {
  position: relative;
}
.advertiserTitle {
  &.mobileTitle {
    font-size: 1.4rem !important;
  }
}
.backNextButtonDisplay {
  position: absolute;
  bottom: 32px;
  right: 140px;
  &.mobileBackNextButtonDisplay {
    position: fixed;
    bottom: 90px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 8;
  }
}
</style>
